import styles from "./FooterActions.module.css";
import { CheckCircle2 } from "lucide-react";

const FooterActions = ({
  saved = true,
  saving = false,
  onCancel,
  onSave,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.bar}>
        <div className={styles.left}>
          {saved && !saving && (
            <div className={styles.saved}>
              <CheckCircle2 size={16} />
              <span>All changes saved</span>
            </div>
          )}
        </div>

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.cancelBtn}
            onClick={onCancel}
            disabled={saving}
          >
            Cancel
          </button>
          <button
            type="button"
            className={styles.saveBtn}
            onClick={onSave}
            disabled={saving}
          >
            {saving ? "Saving…" : "Save Footer Configuration"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FooterActions;
